import React from 'react'
import { InputAdornment, makeStyles } from '@material-ui/core'
import { useFormikContext } from 'formik'

import { FormikTextField, Typography } from 'src/modules/ui'
import { formatPrice } from 'src/utils'

const useStyles = makeStyles(theme => ({
  table: {
    borderSpacing: 0,
    width: '100%',
    '& td': {
      display: 'table-cell',
      paddingBottom: theme.spacing(1),
    },
    '& td:last-child': {
      textAlign: 'right',
    },
    [theme.breakpoints.up('tablet')]: {
      maxWidth: '300px',
    },
  },
  tableContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4),
  },
}))

const InvoiceTotalsInputs = ({ orders }) => {
  const { values } = useFormikContext()
  const classes = useStyles()
  const goodsTotal = orders
    .reduce((a, b) => {
      return parseFloat(a) + parseFloat(b.price)
    }, 0)
    .toFixed(2)

  const subTotal = (
    parseFloat(goodsTotal) +
    parseFloat(values.deliveryCharge || 0) +
    parseFloat(values.otherCharge || 0) -
    parseFloat(values.discount || 0)
  ).toFixed(2)

  const vatTotal = orders
    .reduce((a, b) => {
      return parseFloat(a) + parseFloat(b.vatTotal)
    }, 0)
    .toFixed(2)

  const total = (
    parseFloat(subTotal) +
    parseFloat(vatTotal) -
    parseFloat(values.creditNote || 0)
  ).toFixed(2)

  return (
    <div className={classes.tableContainer}>
      <table className={classes.table}>
        <tbody>
          <tr>
            <td>
              <Typography variant="h5">Goods Total</Typography>
            </td>
            <td>{formatPrice(goodsTotal)}</td>
          </tr>
          <tr>
            <td colSpan={2}>
              <FormikTextField
                name="deliveryCharge"
                margin="normal"
                label="Delivery Charge"
                fullWidth
                placeholder="0.00"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">£</InputAdornment>
                  ),
                }}
              />
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <FormikTextField
                name="otherCharge"
                margin="normal"
                label="Other Charges"
                fullWidth
                placeholder="0.00"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">£</InputAdornment>
                  ),
                }}
              />
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              <FormikTextField
                name="discount"
                margin="normal"
                label="Discount"
                fullWidth
                placeholder="0.00"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">£</InputAdornment>
                  ),
                }}
              />
            </td>
          </tr>
          <tr>
            <td>
              <Typography variant="h5">Subtotal</Typography>
            </td>
            <td>{formatPrice(subTotal)}</td>
          </tr>
          <tr>
            <td>
              <Typography variant="h5">VAT</Typography>
            </td>
            <td>{formatPrice(vatTotal)}</td>
          </tr>
          <tr>
            <td colSpan={2}>
              <FormikTextField
                name="creditNote"
                margin="normal"
                label="Credit Note"
                fullWidth
                placeholder="0.00"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">£</InputAdornment>
                  ),
                }}
              />
            </td>
          </tr>
          <tr>
            <td>
              <Typography variant="h5">Total</Typography>
            </td>
            <td>{formatPrice(total)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default InvoiceTotalsInputs
